import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { StickyHeader } from "./components/landing-new";
import { isLoggedIn, useGlobalState } from "../GlobalStates";
import authAxios from "../authAxios";
import { useTabletOrMobile } from "../hooks/responsive";
import { landingImageDesktop, landingImageMobile } from "../utils/constants";

const LeaderProgrammeOptOut = () => {
  const { t } = useTranslation();
  const [user] = useGlobalState("user");
  const isMobile = useTabletOrMobile();
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const handleOptOut = async () => {
    if (!isLoggedIn(user)) {
      const originalPath = window.location.pathname + window.location.search;
      window.location = `/login?reroute=${encodeURIComponent(originalPath)}`;
      return;
    }

    setLoading(true);
    setError(null);
    try {
      await authAxios.post("/v1/leader/opt-out");
      setDone(true);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          t("leader_opt_out_error", { defaultValue: "Something went wrong. Please try again." })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tw-min-h-screen tw-bg-white">
      <StickyHeader withoutCta />
      <div className="tw-relative tw-flex tw-min-h-screen tw-items-center tw-justify-center">
        {/* Background Image */}
        <div className="tw-absolute tw-inset-0">
          <img
            src={isMobile ? landingImageMobile : landingImageDesktop}
            alt=""
            className="tw-h-full tw-w-full tw-object-cover"
          />
          <div className="tw-absolute tw-inset-0 tw-bg-black/50" />
        </div>

        {/* Content */}
        <div className="tw-relative tw-mx-auto tw-max-w-md tw-px-6 tw-py-16 tw-text-center">
          {done ? (
            <>
              <h1 className="tw-mb-4 tw-text-3xl tw-font-extrabold tw-text-white md:tw-text-4xl">
                {t("leader_opt_out_done_title", { defaultValue: "You've been opted out" })}
              </h1>
              <p className="tw-text-base tw-text-white/80 md:tw-text-lg">
                {t("leader_opt_out_done_desc", {
                  defaultValue:
                    "You will no longer receive updates about the Sotravel leader programme.",
                })}
              </p>
            </>
          ) : (
            <>
              <h1 className="tw-mb-4 tw-text-3xl tw-font-extrabold tw-text-white md:tw-text-4xl">
                {t("leader_opt_out_title")}
              </h1>
              <p className="tw-mb-8 tw-text-base tw-text-white/80 md:tw-text-lg">
                {t("leader_opt_out_desc")}
              </p>
              {error && <p className="tw-mb-4 tw-text-sm tw-text-red-300">{error}</p>}
              <button
                onClick={handleOptOut}
                disabled={loading}
                className="hover:tw-bg-primary-dark tw-rounded-full tw-bg-primary-main tw-px-8 tw-py-4 tw-text-lg tw-font-bold tw-text-white tw-shadow-lg tw-transition-all hover:tw-scale-105 hover:tw-shadow-xl disabled:tw-opacity-50"
              >
                {loading
                  ? t("leader_opt_out_loading", { defaultValue: "Opting out..." })
                  : t("leader_opt_out_button", { defaultValue: "Opt out" })}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderProgrammeOptOut;
